import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactHero from "./sections/ContactHero";
import ContactFormDetails from "./sections/ContactFormDetails";
import PartnershipInquiryCta from "./sections/PartnershipInquiryCta";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactHero />
      <ContactFormDetails />
      <PartnershipInquiryCta />
      <Footer />
    </div>;
}